import React from 'react'
import Layout from '../components/Layout'

const Invoice = () => {
    const today = new Date();
    const future = new Date(today);
    future.setDate(today.getDate() + 365);
    const [totals, setTotals] = React.useState({});

    const [data, setData] = React.useState([{
        "title": "Item Name",
        "quantity": 1,
        "unit": "piece",
        "price": 54
    }]);

    const [invoiceInputs, setInvoiceInputs] = React.useState({
        theme: "Clean",
        invoice_number: "0000002",
        color: "#800000",
        currency: "$",
        date: today.toISOString().split("T")[0],
        due_date: future.toISOString().split("T")[0],
        note: "Thank you for your business 💙",
        tax_rate: 0,
        terms: "Please make checks payable to Brightline Studio Ltd."
    });

    const calculateTotal = () => {
        const subT = data.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);
        const tax = invoiceInputs.tax_rate / 100 * subT;
        setTotals({
            subTotal: subT.toFixed(2), total: (subT + tax).toFixed(2), tax: tax.toFixed(2)
        });
    }

    React.useEffect(() => {
        const subT = data.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);
        const tax = invoiceInputs.tax_rate / 100 * subT;
        setTotals({
            subTotal: subT.toFixed(2), total: (subT + tax).toFixed(2), tax: tax.toFixed(2)
        });
    }, [data, invoiceInputs]);

    const addRow = () => {
        setData(prev => [
            ...prev,
            {
                title: "New Item",
                quantity: 1,
                unit: "",
                price: 10
            }
        ]);
        calculateTotal();
    }

    const removeRow = (indexToRemove) => {
        setData(prev => {
            const newRows = prev.filter((_, index) => index !== indexToRemove);

            return newRows;
        });
        calculateTotal();
    }

    const handleInvoiceInputChange = (k, v) => {
        setInvoiceInputs(prevData => ({
            ...prevData, [k]: v
        }));
        let color = v;
        if (k !== "color") {
            color = invoiceInputs.color;
        }
        document.documentElement.style.setProperty("--main-theme", color);
        calculateTotal();
    }

    function handleInvoiceDataChange(i, k, v) {

        setData(prev => {
            const updated = [...prev];

            updated[i] = {
                ...updated[i],
                [k]: v
            };

            return updated;
        });
        calculateTotal();
    }

    return (
        <Layout
            header="Create a Professional Invoice"
            description="Use our online invoice generator to quickly create, customize, and preview a professional invoice.
Enter client information and line items, then generate a ready-to-download PDF invoice for printing or sending.
Ideal for freelancers, small businesses, and agencies who need fast, accurate, and professional invoicing."
            name="INVOICE" data={data} addData={addRow} handleDataChange={handleInvoiceDataChange}
            removeData={removeRow} inputData={invoiceInputs} handleInputDataChange={handleInvoiceInputChange} optional={{ totals: totals, createNew: true, newButtonText: "LINE ITEM" }}
            styles={["Clean", "Branded"]} />
    )
}

export default Invoice;